import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
import * as React from 'react';
import { useAsync } from 'react-async-hook';
import { DefaultViewDataProvider } from './DataProvider/DefaultViewDataProvider';
import { useViewEvents } from './useViewEvents';
export var LoadingMode = /*#__PURE__*/function (LoadingMode) {
  LoadingMode["WaitForResponse"] = "wait";
  LoadingMode["FallbackButLoadInBackground"] = "debug";
  LoadingMode["FallbackOnly"] = "fallback";
  return LoadingMode;
}({});
export function useViewState(props) {
  var suppliedDataProvider = props.viewDataProvider,
    loadingMode = props.loadingMode,
    piletApi = props.piletApi,
    onError = props.onError,
    metadata = props.metadata;
  var metadataQueryString = metadata ? new URLSearchParams(metadata).toString() : undefined;
  var viewDataProvider = React.useMemo(function () {
    return suppliedDataProvider !== null && suppliedDataProvider !== void 0 ? suppliedDataProvider : new DefaultViewDataProvider();
  }, [suppliedDataProvider]);
  var _useAsync = useAsync(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var viewList, metadataSearchParams, metadataApiParameters, _iterator, _step, _step$value, metadataKey, metadataValue, response, _response, _response2;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            viewList = [];
            metadataSearchParams = new URLSearchParams(metadataQueryString);
            metadataApiParameters = [];
            _iterator = _createForOfIteratorHelper(metadataSearchParams);
            try {
              for (_iterator.s(); !(_step = _iterator.n()).done;) {
                _step$value = _slicedToArray(_step.value, 2), metadataKey = _step$value[0], metadataValue = _step$value[1];
                metadataApiParameters.push("".concat(metadataKey, ":").concat(metadataValue));
              }
            } catch (err) {
              _iterator.e(err);
            } finally {
              _iterator.f();
            }
            if (!isContainerUseViewStateProps(props)) {
              _context.next = 12;
              break;
            }
            _context.next = 8;
            return viewDataProvider.queryViewsAsync(props.containerRID, metadataApiParameters);
          case 8:
            response = _context.sent;
            viewList = _toConsumableArray(response);
            _context.next = 23;
            break;
          case 12:
            if (!isSpecificViewRIDUseViewStateProps(props)) {
              _context.next = 19;
              break;
            }
            _context.next = 15;
            return viewDataProvider.getViewAsync(props.viewRID);
          case 15:
            _response = _context.sent;
            viewList = [_response];
            _context.next = 23;
            break;
          case 19:
            _context.next = 21;
            return viewDataProvider.getViewByIdAsync(props.containerRID, props.viewId);
          case 21:
            _response2 = _context.sent;
            viewList = [_response2];
          case 23:
            return _context.abrupt("return", viewList);
          case 24:
          case "end":
            return _context.stop();
        }
      }, _callee);
    })), [viewDataProvider, metadataQueryString], {
      onError: function (_onError) {
        function onError(_x) {
          return _onError.apply(this, arguments);
        }
        onError.toString = function () {
          return _onError.toString();
        };
        return onError;
      }(function (error) {
        return onError === null || onError === void 0 ? void 0 : onError(error);
      }),
      executeOnMount: loadingMode !== LoadingMode.FallbackOnly
    }),
    loading = _useAsync.loading,
    status = _useAsync.status,
    views = _useAsync.result,
    refetch = _useAsync.execute;
  var refetchViews = React.useCallback(function (affectedRID) {
    if (affectedRID && views && views.find(function (view) {
      return affectedRID.startsWith(view.rid);
    })) {
      refetch();
    }
  }, [views, refetch]);
  useViewEvents({
    piletApi: piletApi,
    viewDataProvider: viewDataProvider,
    refetchViews: refetchViews
  });
  return {
    loading: loading,
    status: status,
    views: views,
    startingViewRID: isContainerUseViewStateProps(props) ? props.startingViewRID : undefined
  };
}
export function isContainerUseViewStateProps(props) {
  return props.hasOwnProperty('containerRID') && !props.hasOwnProperty('viewId');
}
export function isSpecificViewRIDUseViewStateProps(props) {
  return props.hasOwnProperty('viewRID');
}